import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  pax: {
    male: number
    female: number
    childA: number
    childB: number
    childC: number
    childD: number
    childE: number
    childF: number
    childOther: number
  }
}

export const GuestRoomPaxLabel: React.FC<Props> = props => {
  const { t } = useTranslation()
  const paxForAdultText = useMemo(() => {
    return [
      props.pax?.male ? t('cleaningManager.Male', { pax: props.pax?.male }) : undefined,
      props.pax?.female ? t('cleaningManager.Female', { pax: props.pax?.female }) : undefined,
    ].filter(t => t)
  }, [props])

  const paxForChildText = useMemo(() => {
    return [
      props.pax?.childA ? t('cleaningManager.ChildA', { pax: props.pax?.childA }) : undefined,
      props.pax?.childB ? t('cleaningManager.ChildB', { pax: props.pax?.childB }) : undefined,
      props.pax?.childC ? t('cleaningManager.ChildC', { pax: props.pax?.childC }) : undefined,
      props.pax?.childD ? t('cleaningManager.ChildD', { pax: props.pax?.childD }) : undefined,
      props.pax?.childE ? t('cleaningManager.ChildE', { pax: props.pax?.childE }) : undefined,
      props.pax?.childF ? t('cleaningManager.ChildF', { pax: props.pax?.childF }) : undefined,
      props.pax?.childOther ? t('cleaningManager.ChildOther', { pax: props.pax?.childOther }) : undefined,
    ].filter(t => t)
  }, [props])

  return (
    <>
      <div style={{ paddingTop: 8, fontSize: 10, fontWeight: 'bold', lineHeight: 1.5, color: '#676767' }}>
        {<p>大人 : {paxForAdultText.join(' ') || '-'}</p>}
        {<p>子ども : {paxForChildText.join(' ') || '-'}</p>}
      </div>
    </>
  )
}
